/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function removeHash() 
{ 
  var scrollV, scrollH, loc = window.location;
  if ("pushState" in history)
  {
    history.pushState("", document.title, loc.pathname + loc.search);
  }
  else
  {
    scrollV = document.body.scrollTop;
    scrollH = document.body.scrollLeft;
    loc.hash = "";
    document.body.scrollTop = scrollV;
    document.body.scrollLeft = scrollH;
  }
}


var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var fv_player = [];

function onPlayerReady()
{
  for ( var id in fv_player )
  {
    var el = jQuery('#'+id).parent().find('.fiddlehed-video-parts');
    if ( el.is(':hidden') )
    {
      el.show(0);
    }
  }
}

function onYouTubeIframeAPIReady()
{
  jQuery('.fiddlehed-video-youtube').each(function(){
    var el = jQuery(this),
        id = jQuery(this).data('id');
    fv_player['vid_'+id] = new YT.Player('vid_'+id, {
      height: '315',
      width: '560',
      videoId: id,
      events: {
        'onReady': onPlayerReady
      }
    });
    el.find('a').each(function(){
      jQuery(this).click(function(e){
        fv_player['vid_'+id].seekTo(jQuery(this).data('time'));
        fv_player['vid_'+id].playVideo();
        e.preventDefault();
        e.stopPropagation();
      });
    });
  });
}

jQuery('.fiddlehed-video-vimeo').each(function(){
  var iframe = jQuery(this).find('iframe');
  var player = new Vimeo.Player(iframe);
  jQuery(this).find('a').each(function(){
    jQuery(this).click(function(e){
      player.setCurrentTime(jQuery(this).data('time'));
      player.play();
      e.preventDefault();
      e.stopPropagation();
    });
  });
});


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $( "#nav-mobile" ).click(function() {
          $(".banner nav").toggleClass('mobile-menu-open');
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  $('.vc_tta-panels .vc_tta-panel.vc_active').removeClass('vc_active');
  $('.vc_tta-panels .vc_tta-panel .vc_tta-panel-title a').click(function(e){
    var el = $(this).parent().parent().parent();
    if ( el.hasClass('vc_active') )
    {
      el.find('.vc_tta-panel-body').slideUp(300,function(){
        el.removeClass('vc_active');
        removeHash();
      });
      e.preventDefault();
      e.stopPropagation();
    }
  });

  $('.fiddlehed-video-part').click(function(e){
    var id = $(this).data('id'),
        time = $(this).data('time'),
        src = $(this).data('src');
    $('#'+id).html('<iframe src="' + src + '?autoplay=1&t=' + time + '" width="560" height="315" frameborder="0" allowfullscreen="allowfullscreen"></iframe>');
    e.preventDefault();
    e.stopPropagation();
  });

  $('#bbp_reply_submit').click(function(e){ $('#new-post').addClass('loading'); });
  $('#aw-whats-new-submit').click(function(e){ $('#whats-new-form').addClass('loading'); });

  $(document).ready(function(){
    setTimeout(function(){
      if ( !map_download )
      {
        $('.map_download').remove();
      }
    },5000);
  });

})(jQuery); // Fully reference jQuery after this point.
